<div class="view-component-title">{{'tiktok.brand.title'|translateTA}}</div>
<div class="content">

  <div class="bar-action">
    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
      <input type="text" nz-input placeholder="{{'input.search'|translateTA}}" [(ngModel)]="name" />
    </nz-input-group>
    <ng-template #suffixIconButton>
      <button nz-button nzType="primary" (click)="onFilterChange()" nzSearch><span nz-icon nzType="search"></span></button>
    </ng-template>
    <mat-divider vertical="true"></mat-divider>
    <label>
      <span style="margin-left: 2px; font-weight: 500;">{{'authorized'|translateTA}}</span>
      <nz-switch [ngModel]="authrorized" (ngModelChange)="onSwitch($event)"></nz-switch>
    </label>

    
  </div>
  <div class="table-container">
      <nz-table  
              #basicTable 
              [nzPaginationType]="'small'"
              [nzShowPagination]="true"
              [nzSize]="'small'"
              [nzPageSize]="pageSize"
              [nzPageIndex]="pageIndex"
              [nzData]="filteredPagedRows"
              [nzTotal]="filteredPagedRows.length" 
              [nzBordered]="true" 
              [nzLoading]="loading"
              [nzTableLayout]="'fixed'">
          <thead>
          <tr>
              <th [nzShowSort]="true" [nzSortDirections]="['ascend', 'descend', null]" [nzSortFn]="idSort" [nzSortOrder]="null" >{{'tiktok.brand.id'|translateTA}}</th>
              <th colspan="2" [nzShowSort]="true"[nzSortDirections]="['ascend', 'descend', null]" [nzSortFn]="nameSort"  [nzSortOrder]="null">{{'tiktok.brand.name'|translateTA}}</th>
              <th [nzShowSort]="true" [nzSortDirections]="['ascend', 'descend', null]" [nzSortFn]="brand_statusSort" [nzSortOrder]="null" >{{'tiktok.brand.brand_status'|translateTA}}</th>
              <th [nzShowSort]="true" [nzSortDirections]="['ascend', 'descend', null]" [nzSortFn]="authorized_statusSort" [nzSortOrder]="null" >{{'tiktok.brand.authorized_status'|translateTA}}</th>
          </tr>
          </thead>
          <tbody>
              <tr *ngFor="let data of basicTable.data; trackBy: trackById" (dblclick)="editRow(data)">
                  <td style="font-size: 90%;">{{data.id}}</td>
                  <td colspan="2">{{data.name}}</td>
                  <td>{{data.brand_status|translateTA}}</td>
                  <td>{{data.authorized_status|translateTA}}</td>
              </tr>
          </tbody>
    </nz-table>
  </div>
  <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>